import * as React from "react";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import { useLoading } from "../../hooks/LoadingContext";

export default function GeneralLoader() {
  const { isLoading, progress, setProgress } = useLoading();

  React.useEffect(() => {
    if (isLoading) {
      const timer = setInterval(() => {
        setProgress((oldProgress) => {
          if (oldProgress === 100) {
            return 0;
          }
          const diff = Math.random() * 10;
          return Math.min(oldProgress + diff, 100);
        });
      }, 100);

      return () => {
        clearInterval(timer);
      };
    } else {
      setProgress(0);
    }
  }, [isLoading, setProgress]);

  return (
    <Box sx={{ width: "100%" }}>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={(theme) => ({
          background: "linear-gradient(to right, #ff6a00, #ee0979)",
          height: 4,
          borderRadius: 2,
          boxShadow: "0 0 6px rgba(255, 105, 135, 0.6)",
        })}
      />
    </Box>
  );
}
